import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateOpportunitySourceRequest extends BaseUpdateRequest {
    name = '';
}
